module.exports = __webpack_public_path__ + "static/img/guanliceng.581d16bd.png";